<template>
  <div>
    <v-alert
      v-if="$getDeepObj(initValue, 'alasan') && Number($getDeepObj(initValue, 'k_verval_paud')) === 5"
      class="bg-notif"
      border="left"
      colored-border
      color="orange"
      icon="mdi-file-edit"
    >
      <div class="black--text">
        Catatan Perbaikan:<br />
        {{ $getDeepObj(initValue, 'alasan') }}
      </div>
    </v-alert>
    <v-card flat class="pa-2">
      <v-card-text>
        <h1 class="headline black--text font-weight-medium">Data Ajuan Klaim Diklat</h1>
        <p>
          Lengkapi form yang tersedia dibawah ini sebagai syarat data ajuan klaim diklat yang telah Anda ikut sebelumnya
        </p>
        <div class="mt-5">
          <base-form-generator v-model="form" :schema="schema" />
          <h3 class="my-2">Berkas Unggahan</h3>
          <template v-if="url_file">
            <v-chip color="primary" dark label close :href="url_file" target="_blank" @click:close="onRemoveFile">
              {{ url_file }}
            </v-chip>
          </template>
          <template v-else>
            <validation-provider name="Sertifikat Diklat" rules="required" v-slot="{ errors }">
              <div class="body-2" style="color: #bf360c !important">Unggah Setifikat Diklat *</div>
              <v-file-input
                v-model="form['file']"
                :error-messages="errors"
                label="Pindaian Berkas Sertifikat (20 KB - 1,5 MB)"
                append-icon="mdi-paperclip"
                prepend-icon=""
                accept="image/*,.pdf"
                show-size
                outlined
                dense
                single-line
              ></v-file-input>
            </validation-provider>
            <div class="grey--text font-italic mt-n6">
              <v-icon small>mdi-information</v-icon> Jenis file unggahan harus pertipe JPG/JPEG/PNG/GIF/PDF
            </div>
          </template>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import BaseFormGenerator from '@components/base/BaseFormGenerator';
import { ValidationProvider } from 'vee-validate';

export default {
  props: {
    masters: {
      type: Object,
      default: () => {},
    },
    initValue: {
      type: Object,
      default: () => null,
    },
  },
  components: { BaseFormGenerator, ValidationProvider },
  data() {
    return {
      form: {},
      url_file: null,
    };
  },
  computed: {
    schema() {
      let instansiLpd = this.masters.instansi || [];
      if (instansiLpd.findIndex((s) => Number(s.value) === 99) === -1) {
        instansiLpd.push({
          value: 99,
          text: 'Lainnya',
        });
      }
      let jenisDiklat = this.masters.diklat_paud || [];
      const isLainnya = jenisDiklat.findIndex((s) => Number(s.value) === 4);
      if (isLainnya > 1) {
        jenisDiklat.splice(isLainnya, 1);
      }

      let temp = [
        {
          type: 'VTextField',
          name: 'nama',
          label: 'Nama Diklat',
          dense: true,
          hint: 'wajib diisi',
          placeholder: 'Isikan Nama Diklat',
          required: true,
          hideDetails: false,
          outlined: true,
          singleLine: true,
          grid: { cols: 12, md: 12 },
          labelColor: 'secondary',
        },
        {
          type: 'VSelect',
          name: 'k_diklat_paud',
          label: 'Jenis Diklat',
          dense: true,
          hint: 'wajib dipilih',
          placeholder: 'Pilih Jenis Diklat',
          items: jenisDiklat,
          required: true,
          hideDetails: false,
          outlined: true,
          singleLine: true,
          grid: { cols: 12, md: 6 },
          labelColor: 'secondary',
        },
        {
          type: 'VSelect',
          name: 'k_tingkat_diklat_paud',
          label: 'Jenjang Diklat',
          dense: true,
          hint: 'wajib dipilih',
          placeholder: 'Pilih Jenjang Diklat',
          items: this.masters.jenjang_diklat_paud,
          required: true,
          hideDetails: false,
          outlined: true,
          singleLine: true,
          grid: { cols: 12, md: 6 },
          labelColor: 'secondary',
        },
        {
          type: 'VDatePicker',
          name: 'tgl_mulai',
          label: 'Tanggal Mulai',
          dense: true,
          hint: 'wajib dipilih',
          placeholder: 'Pilih Tanggal',
          required: true,
          hideDetails: false,
          outlined: true,
          singleLine: true,
          grid: { cols: 12, md: 6 },
          labelColor: 'secondary',
        },
        {
          type: 'VDatePicker',
          name: 'tgl_selesai',
          label: 'Tanggal Selesai',
          dense: true,
          hint: 'wajib dipilih',
          placeholder: 'Pilih Tanggal',
          required: true,
          hideDetails: false,
          outlined: true,
          singleLine: true,
          grid: { cols: 12, md: 6 },
          min: this.$getDeepObj(this.form, 'tgl_mulai'),
          labelColor: 'secondary',
        },
        {
          type: 'VAutocomplete',
          name: 'instansi_id_lpd',
          label: 'Lembaga Penyelenggara Diklat (LPD)',
          dense: true,
          hint: 'wajib dipilih',
          placeholder: 'Pilih lembaga penyelenggara',
          items: instansiLpd,
          required: true,
          hideDetails: false,
          outlined: true,
          singleLine: true,
          grid: { cols: 12, md: 6 },
          labelColor: 'secondary',
        },
        {
          type: 'VTextField',
          name: 'satminkal',
          label: 'Instansi / Satminkal',
          dense: true,
          hint: 'wajib diisi',
          placeholder: 'Isikan Nama Diklat',
          required: true,
          hideDetails: false,
          outlined: true,
          singleLine: true,
          grid: { cols: 12, md: 6 },
          labelColor: 'secondary',
        },
      ];

      if (this.$getDeepObj(this.form, 'instansi_id_lpd') === 99) {
        temp.push({
          type: 'VTextarea',
          name: 'catatan',
          label: 'Catatan',
          dense: true,
          hint: 'wajib diisi',
          placeholder: 'Catatan',
          required: true,
          hideDetails: false,
          outlined: true,
          singleLine: true,
          grid: { cols: 12, md: 12 },
          labelColor: 'secondary',
        });
      }

      return temp;
    },
  },

  methods: {
    reset() {
      this.$set(this, 'form', {});
      this.$set(this, 'url_file', null);
    },

    onRemoveFile() {
      this.$set(this, 'url_file', null);
    },

    initForm(value) {
      const formulir = [...(this.schema || [])];

      for (const item of formulir) {
        if (item.name) {
          this.$set(this.form, item.name, this.$getDeepObj(value, item.name) || '');
        }
      }

      if (value && value.catatan && value.instansi_id_lpd === null) {
        this.$set(this.form, 'instansi_id_lpd', 99);
        this.$set(this.form, 'catatan', value.catatan);
      }

      if (value && value.url) {
        this.$set(this, 'url_file', value.url);
      }
    },

    mutate(value) {
      if (value && value.instansi_id_lpd !== 99) {
        this.$delete(this.form, 'catatan');
      }
    },
  },

  watch: {
    initValue: 'initForm',
    form: {
      handler(value) {
        this.mutate(value);
      },
      deep: true,
    },
  },
};
</script>
